import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import Sidebar from "../components/common-components/sidebar";
import { Toaster } from "react-hot-toast";
import '../styles/Dashboard.css';

const AdminLayout = ({
  children
}: any) => {

  return (
    <>
      <Container fluid>
        <Row>
          <Col xs={2} id="sidebar-wrapper-admin">
            <Sidebar />
          </Col>
          <Col className="p-4" xs={10} id="page-content-wrapper">
            {children}
          </Col>
          <Toaster
            position="bottom-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                backgroundColor: "#00B38F",
                color: "#fff",
              },
            }}
          />
        </Row>
      </Container>
    </>
  );
};
export default AdminLayout;